export const REQUESTED_QUOTE_STATUSES = new Set([
  "pending",
  "in_review",
  "quoted",
  "revision_requested",
]);

export const SIDEBAR_QUOTE_STATUSES = new Set([
  "pending",
  "in_review",
  "quoted",
]);

export const HISTORY_QUOTE_STATUSES = new Set([
  "ordered",
  "accepted",
  "rejected",
  "closed",
]);

export const STATUS_LABELS = {
  pending: "Pending",
  in_review: "In review",
  quoted: "Quoted",
  revision_requested: "Revision requested",
  ordered: "Ordered",
  accepted: "Accepted",
  rejected: "Rejected",
  closed: "Closed",
};

export const STATUS_STYLES = {
  pending: {
    chip: { bgcolor: "rgba(245, 158, 11, 0.12)", color: "#b45309" },
  },
  in_review: {
    chip: { bgcolor: "rgba(30, 90, 158, 0.1)", color: "#1e5a9e" },
  },
  quoted: {
    chip: { bgcolor: "rgba(22, 163, 74, 0.12)", color: "#15803d" },
  },
  revision_requested: {
    chip: { bgcolor: "rgba(124, 58, 237, 0.12)", color: "#6d28d9" },
  },
  ordered: {
    chip: { bgcolor: "rgba(22, 163, 74, 0.12)", color: "#15803d" },
  },
  accepted: {
    chip: { bgcolor: "rgba(22, 163, 74, 0.12)", color: "#15803d" },
  },
  rejected: {
    chip: { bgcolor: "rgba(220, 38, 38, 0.12)", color: "#b91c1c" },
  },
  closed: {
    chip: { bgcolor: "rgba(100, 116, 139, 0.14)", color: "#475569" },
  },
};

export function normalizeQuoteStatus(status) {
  return String(status ?? "pending")
    .toLowerCase()
    .trim();
}

export function isRequestedQuote(quote) {
  return REQUESTED_QUOTE_STATUSES.has(normalizeQuoteStatus(quote?.status));
}

export function isHistoryQuote(quote) {
  return HISTORY_QUOTE_STATUSES.has(normalizeQuoteStatus(quote?.status));
}

export function isPendingQuote(quote) {
  return normalizeQuoteStatus(quote?.status) === "pending";
}

export function isSidebarQuote(quote) {
  return SIDEBAR_QUOTE_STATUSES.has(normalizeQuoteStatus(quote?.status));
}

/** User can edit quantities while quote is still active (not history). */
export function isQuoteEditable(quote) {
  return isSidebarQuote(quote);
}

/** Keep editable status in UI when API wrongly returns history after a line edit. */
export function preserveQuoteStatusAfterLineEdit(beforeQuote, apiQuote) {
  if (!beforeQuote || !apiQuote) return apiQuote;
  if (!isQuoteEditable(beforeQuote)) return apiQuote;

  const beforeStatus = normalizeQuoteStatus(beforeQuote.status);
  const freshStatus = normalizeQuoteStatus(apiQuote.status);

  if (beforeStatus !== freshStatus && isHistoryQuote(apiQuote)) {
    return { ...apiQuote, status: beforeQuote.status };
  }

  return apiQuote;
}

export function didLineEditChangeToHistoryStatus(beforeQuote, apiQuote) {
  if (!beforeQuote || !apiQuote) return false;
  const beforeStatus = normalizeQuoteStatus(beforeQuote.status);
  if (beforeStatus !== "quoted") return false;
  return (
    isHistoryQuote(apiQuote) &&
    normalizeQuoteStatus(apiQuote.status) !== beforeStatus
  );
}

export function filterQuotesByMode(quotes, mode) {
  const list = Array.isArray(quotes) ? quotes : [];
  if (mode === "history") {
    return list.filter(isHistoryQuote);
  }
  return list.filter(isRequestedQuote);
}

export function countQuotesByMode(quotes) {
  const list = Array.isArray(quotes) ? quotes : [];
  return {
    requested: list.filter(isRequestedQuote).length,
    history: list.filter(isHistoryQuote).length,
  };
}
